function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.8 15.4a4 4 0 0 1 .8-5.6l4.6-3.45a3 3 0 0 1 3.6 0l4.6 3.45a4 4 0 1 1-4.8 6.4c-.64-.48-1.177-.7-1.6-.7-.423 0-.96.22-1.6.7a4 4 0 0 1-5.6-.8zM9 13.5c.91 0 1.84.38 2.8 1.1a2 2 0 1 0 2.4-3.2L9.6 7.95a1 1 0 0 0-1.2 0L3.8 11.4a2 2 0 1 0 2.4 3.2c.96-.72 1.89-1.1 2.8-1.1zM1.5 8C.672 8 0 7.105 0 6s.672-2 1.5-2S3 4.895 3 6s-.672 2-1.5 2zM6 5C4.895 5 4 3.88 4 2.5S4.895 0 6 0s2 1.12 2 2.5S7.105 5 6 5zm6 0c-1.105 0-2-1.12-2-2.5S10.895 0 12 0s2 1.12 2 2.5S13.105 5 12 5zm4.5 3c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2zm-.7 22.4a4 4 0 0 1 .8-5.6l4.6-3.45a3 3 0 0 1 3.6 0l4.6 3.45a4 4 0 1 1-4.8 6.4c-.64-.48-1.177-.7-1.6-.7-.423 0-.96.22-1.6.7a4 4 0 0 1-5.6-.8zm4.4-.8c.96-.72 1.89-1.1 2.8-1.1.91 0 1.84.38 2.8 1.1a2 2 0 1 0 2.4-3.2l-4.6-3.45a1 1 0 0 0-1.2 0l-4.6 3.45a2 2 0 1 0 2.4 3.2zM15.5 23c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2zm4.5-3c-1.105 0-2-1.12-2-2.5s.895-2.5 2-2.5 2 1.12 2 2.5-.895 2.5-2 2.5zm6 0c-1.105 0-2-1.12-2-2.5s.895-2.5 2-2.5 2 1.12 2 2.5-.895 2.5-2 2.5zm4.5 3c-.828 0-1.5-.895-1.5-2s.672-2 1.5-2 1.5.895 1.5 2-.672 2-1.5 2z"
});

var SvgWalking = function SvgWalking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "f5798eda524668f8542eed4adfc8c561.svg";
export { SvgWalking as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/walking.svg
// module id = null
// module chunks = 